import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Index from "../views/Index.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: Index,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "",
  scrollBehavior: (to) => {
    const el: HTMLAnchorElement | null =
      document.querySelector(".header-anchor");
    if (el) {
      if (to.hash == el.hash) return { top: 0 };
    }
    if (to.hash) {
      setTimeout(() => {
        const getHash: string | null = window.location.href.split("#")[1];
        const el: HTMLElement | null = document.getElementById(getHash);
        return window.scrollTo({
          top: el?.offsetTop,
          behavior: "smooth",
        });
      }, 200);
    } else {
      return { top: 0 };
    }
  },
});

export default router;
